import {
  GoabBlock,
  GoabSpacer,
  GoabText,
} from "@abgov/react-components";
import warning from "../../assets/warning.svg";
import { IconCircle } from "../IconCircle/IconCircle";
import { BrandDivider } from "../BrandDivider/BrandDivider";
import { fullPageCenter } from "./ErrorPage.styles";

export const ErrorPage = ({ errorCode, heading, children, icon = warning, iconAlt = "Warning", styles }) => {
  return (
    <div style={fullPageCenter}>
      <GoabBlock direction="column" alignment="center">
        <IconCircle src={icon} alt={iconAlt} />
        {errorCode ? (
          <GoabText color="secondary" tag="span">
            {errorCode}
          </GoabText>
        ) : (
          <GoabSpacer vSpacing={"m"} />
        )}
        <BrandDivider />
      </GoabBlock>
      <GoabSpacer vSpacing="xl" />
      <h2>{heading}</h2>
      <GoabSpacer vSpacing="l" />
      {children}
    </div>
  );
};

export default ErrorPage;